import { minutesToTime } from './util.js';

export class DayAbsence {

    constructor(app, user, data) {
        this.app = app;
        this.user = user;
        this.data = data;
        this.pupil = user.type === 'teacher' ? this.app.dm.getUser(this.data.pupilId) : user;
    }

    getCssClasses() {
        let cssClasses = '';
        if (this.data.absenceType === 'missing' && !this.data.justified) cssClasses += ' missing';
        if (!this.data.justified && this.data.absenceType !== 'school') cssClasses += ' not-justified';
        if (this.data.hourFrom && this.data.hourFrom !== 0) cssClasses += ' from-hour';
        return cssClasses;
    }

    getIcon() {
        let icon = '☎';
        if (this.data.absenceType === 'late') icon = "🕑";
        else if (this.data.absenceType === 'missing') icon = '❓';
        else if (this.data.absenceType === 'school') icon = '🎓';
        return icon;
    }

    getNotes(currentDate) {

        const notes = [];
        if (this.data.absenceType === 'late') notes.push(this.data.lateTime+ "'");

        if (this.data.dateFrom === this.data.dateTo) {
            if (this.data.absentTo !== 0 && this.data.absentFrom !== 0) {
                if (this.data.absentFrom < this.data.absentTo) {
                    notes.push('ab '   + minutesToTime(this.data.absentFrom) + ' Uhr');
                    notes.push('bis '  + minutesToTime(this.data.absentTo) + ' Uhr');
                }
                else {
                    notes.push('bis '  + minutesToTime(this.data.absentTo) + ' Uhr');
                    notes.push('ab '   + minutesToTime(this.data.absentFrom) + ' Uhr');
                }
            }
            else {
                if (this.data.absentTo   !== 0) notes.push('bis '  + minutesToTime(this.data.absentTo) + ' Uhr');
                if (this.data.absentFrom !== 0) notes.push('ab '   + minutesToTime(this.data.absentFrom) + ' Uhr');
            }
        }               
        else {
            if (this.data.absentFrom   !== 0 && (this.data.dateFrom === currentDate)) notes.push('ab '  + minutesToTime(this.data.absentFrom) + ' Uhr');
            if (this.data.absentTo !== 0 && (this.data.dateTo   === currentDate)) notes.push('bis '   + minutesToTime(this.data.absentTo) + ' Uhr');
        }

        if (this.data.note.length) notes.push(this.data.note);

        return notes.length ? (' (' + notes.join(', ') + ')') : '';

    }

}